<mbs-modal
  [title]="baseModal.data.title"
  [isCustomModal]="true"
  [showFooter]="true"
  [titleTextOverflow]="true"
  #modal>
  <div modal-body>
    @if (this.baseModal.data.licenseName && this.baseModal.data.cost) {
      <div>
        <span class="fw-bold">{{ 'shared:common.license' | i18next }}</span>
      </div>
      <div class="mb-3">
        <span>{{ this.baseModal.data.licenseName }}</span>
      </div>
      <div>
        <span class="fw-bold">{{ 'shared:licenses.cost' | i18next }}</span>
      </div>
      <div class="mb-3">
        <span>{{ this.baseModal.data.cost | price | async }}</span>
      </div>
    }

    @if (!this.baseModal.data.isAdminPage) {
      <div class="mb-3">
        {{ 'shared:licenses.enableAutoRenewalModal.hint' | i18next }}
      </div>
    }
    <div>
      {{
        (baseModal.data.itemsCount === 1
          ? 'shared:licenses.enableAutoRenewalModal.descriptionForOneLicense'
          : 'shared:licenses.enableAutoRenewalModal.description'
        ) | i18next: { count: baseModal.data.itemsCount }
      }}
    </div>
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [loading]="loading"
      (click)="enable()"
      >{{ 'shared:licenses.enableAutoRenewalModal.submit' | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      data-dismiss="modal"
      (click)="modal.close()"
      >{{ 'shared:licenses.common.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
